import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../redux/actions';
import { SaoPauloTitle } from '../Title/SaoPauloTitle';
import { constant } from 'lodash';

export const Service1 = ({ operator , sectionHeading , items, boldTitle}) => {
  
  return (
    <div>
     {sectionHeading &&  <SaoPauloTitle title={ sectionHeading } operator={operator} />}
      <div className="themes-service-1 new-container mt10">
        {items.map((item, key) => {
          return (
            <div className="service-single-item" style={{ width:`${100/items.length}%` , background: key%2 != 0 ? "#EAEAEA" : " "}}>
              {item.icon && <div>
                <img src={item.icon} style={{ height: 85 }} />
              </div>}
              <div style={{display:'flex', alignItems:'center', marginTop: 20 , fontWeight: boldTitle ? 'bold' : 'normal' }} className="font12">
              {item.inlineIcon && <img src={item.inlineIcon} style={{ width: 15 , marginRight:10}} />} 
              {item.text}
              </div>
              <div style={{ marginTop: 20 ,lineHeight:1.4, textAlign:'center' }} className={item.inlineIcon ? 'font9 center' :'font11 center' }>
                {item.body && item.body}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    themes: state.themes,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Service1);



// WEBPACK FOOTER //
// ./src/features/themes/common/Services/Service1.js